import { WinSpinePopup } from "./WinSpinePopup";

const WIN_TYPES = {
    SUPER: 0,
    GREAT: 1,
    AMAZING: 2,
};

export const WIN_TYPES_BY_LEVEL = [WIN_TYPES.SUPER,WIN_TYPES.GREAT,WIN_TYPES.AMAZING];

// mega_in
// mega_loop
// mega_out
// nice_in
// nice_loop
// nice_out
// sensational_in
// sensational_loop
// sensational_out
// super_in
// super_loop
// super_out

export class WinsPopupScene extends WinSpinePopup {
    static SEQUENCE_BY_TYPE = {
        [WIN_TYPES.SUPER]: [
            { animation: "nice_in", sfx: { name: "super_win" } },
            { animation: "nice_loop",loop: 2 },
            { animation: "nice_out" },
            ],
        [WIN_TYPES.GREAT]: [
            { animation: "super_in", loop: 1, sfx: { name: "great_win" } },
            { animation: "super_loop", loop: 3 },
            { animation: "super_out" },
        ],
        [WIN_TYPES.AMAZING]: [
            { animation: "mega_in", sfx: { name: "amazing_win" }  },
            { animation: "mega_loop", loop: 4 },
            { animation: "mega_out" },
        ],
    };

    constructor({ win, level = 0, ...parameters }) {
        super({
            ...parameters,
            spine: "WinsAnimation",
            win: win,
            winValueSlotName: ["win_summ"],
            sequence: WinsPopupScene.SEQUENCE_BY_TYPE[level],
        });
    }
}
